import { SUPPORTED_AUDIO_EXTENSIONS } from './constants'

export const isAudioFile = (file: File): boolean => {
  return SUPPORTED_AUDIO_EXTENSIONS.some((ext) =>
    file.name.toLowerCase().endsWith(`.${ext.toLocaleLowerCase()}`),
  )
}

export const isAudioFilePath = (path: string | null | undefined): boolean => {
  if (path == null) return false
  return SUPPORTED_AUDIO_EXTENSIONS.some((ext) =>
    path.toLowerCase().endsWith(`.${ext.toLowerCase()}`),
  )
}

export const calculateAudioDuration = (file: File): Promise<number | null> => {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const mediaElement = document.createElement(
      file.type.startsWith('audio') ? 'audio' : 'video',
    )
    mediaElement.src = url
    mediaElement.addEventListener('loadedmetadata', function () {
      // batch は音声実長を切り捨てで保存し 90 秒判定に使うため、同じ丸めにする
      const duration = Math.floor(mediaElement.duration)
      resolve(duration)
      URL.revokeObjectURL(url)
    })

    mediaElement.addEventListener('error', function () {
      resolve(null)
      URL.revokeObjectURL(url)
    })
  })
}
